import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-insurance-spot-small',
    template: `
        <div
            class="insurance-spot-small"
            (click)="getClickedCompanyName.emit(insurance.companyName)"
            [class.insurance-spot-small--active]="activeCompany === insurance.companyName"
            appCircleCheckmark
            [condition]="activeCompany === insurance.companyName"
        >
            <img *ngIf="insurance.companyLogo?.src" class="insurance-spot-small__logo" [src]="insurance.companyLogo.src | resolveMediaUrl : { format: 'webp', width: 170 }" loading="lazy" />
        </div>
    `,
})
export class InsuranceSpotSmallComponent {
    @Input() insurance: Cms.InsuranceCompany;
    @Input() activeCompany?: string | null;
    @Output() getClickedCompanyName = new EventEmitter<string>();
}
